module.exports = __webpack_public_path__ + "2889affabac83dfd1fd0cae4f5f8bd98.png";